import { GENDERS } from './ProjectConstants';

const ETHNICITIES = [
  'Asian or Pacific Islander',
  'Black or African American',
  'Hispanic or Latino',
  'Multiracial or Biracial',
  'Native American or Alaskan Native',
  'White or Caucasian',
  'An ethnicity not listed here',
];

export const EMPLOYEE_FIELDS_LIST = [
  {
    id: 'firstName',
    title: 'First Name',
    type: 'text',
    defaultValue: '',
    isRequired: true,
    showInProfile: true,
  },
  {
    id: 'lastName',
    title: 'Last Name',
    type: 'text',
    defaultValue: '',
    showInProfile: true,
  },
  {
    id: 'preferredName',
    title: 'Preferred Name',
    type: 'text',
    defaultValue: '',
    showInProfile: true,
  },
  {
    id: 'gender',
    title: 'Gender',
    type: 'select',
    defaultValue: null,
    options: Object.keys(GENDERS).map((gender) => ({
      value: GENDERS[gender].key,
      label: GENDERS[gender].label,
    })),
    showInProfile: true,
  },
  {
    id: 'ethnicity',
    title: 'Ethnicity',
    type: 'creatableSelect',
    defaultValue: null,
    options: ETHNICITIES.map((dpt) => ({ value: dpt, label: dpt })),
    showInProfile: true,
  },
  {
    id: 'email',
    title: 'Email',
    type: 'text',
    defaultValue: '',
    isRequired: true,
    showInProfile: true,
  },
  {
    id: 'managerEmail',
    title: 'Manager Email',
    type: 'email-autocomplete',
    defaultValue: '',
    options: [],
    showInProfile: true,
  },
  {
    id: 'joiningDate',
    title: 'Joining Date',
    type: 'date',
    defaultValue: undefined,
    showInProfile: true,
  },
  {
    id: 'dateOfBirth',
    title: 'Date of Birth',
    type: 'date',
    defaultValue: undefined,
    showInProfile: true,
  },
  {
    id: 'country',
    title: 'Country',
    type: 'text',
    defaultValue: '',
    showInProfile: true,
  },
  {
    id: 'employeeAccesses',
    title: 'Admin Access',
    type: 'customMultiSelect',
    defaultValue: null,
    options: [],
    isRequired: false,
    showInProfile: true,
  },
  {
    id: 'designation',
    title: 'Designation',
    type: 'text',
    defaultValue: '',
    showInProfile: true,
  },
  // {
  //   id: 'department',
  //   title: 'Department',
  //   type: 'asyncCreatableSelect',
  //   defaultValue: null,
  //   options: DEPARTMENTS.map(dpt => ({ value: dpt, label: dpt })),
  //   showInProfile: true
  // },
  {
    id: 'location',
    title: 'Location',
    type: 'text',
    defaultValue: '',
    showInProfile: true,
  },
  // {
  //   id: 'designation',
  //   title: 'Role',
  //   type: 'text',
  //   defaultValue: '',
  //   showInProfile: true
  // },
  // {
  //   id: 'primaryPod',
  //   title: 'Primary Pod',
  //   type: 'primaryPod-select',
  //   defaultValue: null,
  //   showInProfile: false
  // }
  // {
  //   id: 'secondaryPods',
  //   title: 'Secondary Pods',
  //   type: 'secondaryPods-select',
  //   defaultValue: null,
  //   showInProfile: false
  // }
  // {
  //   id: 'employeeFunction',
  //   title: 'Function',
  //   type: 'text',
  //   defaultValue: null,
  //   showInProfile: true
  // },
  // {
  //   id: 'grade',
  //   title: 'Grade',
  //   type: 'text',
  //   defaultValue: null,
  //   showInProfile: false
  // }
];
